import type { Editor as EditorCore } from "@tiptap/react";
import { EditorContent } from "@tiptap/react";

import { useLinkDialog } from "./hooks/useLinkDialog";
import { ITagResponse } from "@interfaces/responses.interface";
import { TagsTypes } from "@components/Sections/TagsSection/constants";
import { Spotlight } from "@components/Spotlight";

export type EditorProps = {
  editor: EditorCore;
  selectedTags: ITagResponse[];
  keyForTypes: keyof typeof TagsTypes;
  className?: string;
};

export function Editor({ editor, selectedTags, keyForTypes, className }: EditorProps) {
  useLinkDialog(editor);

  if (!editor) return null;

  return (
    <div className="contents">
      <EditorContent className={className} editor={editor} />
      <Spotlight editor={editor} selectedTags={selectedTags} keyForTypes={keyForTypes} />
    </div>
  );
}
